// this file added by Bearer Web Developer
import React from 'react';
import styles from './fee.module.scss';
import { useThemeMode } from '../../../../states/contexts/theme';
import { useAppState } from '../../../../states/app-state';
import { TCancellationCost } from '../../../../states/cancellationCostState';
import { observer } from 'mobx-react-lite';

const Fee: React.FC = observer(() => {

    const { theme } = useThemeMode(); // added by Bearer Web Developer
    const appState = useAppState();
    const { selectedOrder: order } = appState;
    const code: TCancellationCost | null | undefined = order?.cancellationCost?.cancellingStateCode;
    const timeN = order?.cancellationCost?.timeN || '';
    const timeM = order?.cancellationCost?.timeM || '';
    const cancellationFee = order?.cancellationCost?.cancellationFee || '';
    const totalCancellation = order?.cancellationCost?.totalCancellation || '';
    const waitingFee = order?.cancellationCost?.waitingFee || '';
    const feeText =
        code === "2.1" || code === "2.2.2" ? "Free"
            : code === "2.2.1" ? `A$${cancellationFee} cancellation fee`
                : code === "3.1" ? `A$${totalCancellation} cancellation fee`
                    : `A$${totalCancellation} cancellation fee`;
    return (
        <div className={styles.fee} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <div className={styles.text}>
                <img src={theme === "dark" ? "/note.svg" : "/note-black.svg"} alt="" width={22} height={22} />
                <div>
                    <h5>Fee: <span className={feeText !== "Free" ? styles.red : ''}>{feeText}</span></h5>
                    {
                        code === "2.1" ?
                            <p>You’re cancelling shortly {`(< ${timeN} minutes)`} after your Bearer accepted the delivery. No fee applies because they have not yet committed significant travel time.</p>
                            : code === "2.2.2" ? // 2.2 in design
                                <p>No fee applies because your Bearer's arrival time has not improved since accepting the delivery.</p>
                                : code === "2.2.1" ? // 2.3 in design
                                    <p>Your Bearer has already started travelling to the pickup location {`(> ${timeN} minutes ago)`}. This fee covers their time, availability, and travel commitment made for your delivery.</p>
                                    : code === "3.1" ? <p>Your Bearer has arrived at the pickup location and reserved time specifically for your delivery. The base fare compensates them for their completed travel and commitment.</p>
                                        // code === "3.2" in the following
                                        : <p>Your Bearer has arrived and waited at the pickup location beyond the grace period {`(${timeM} minutes)`}. This fee covers their travel and the additional time reserved while waiting.</p>

                    }
                </div>
            </div>
            {
                code === "3.2" &&
                <div className={styles.info}>
                    <hr />
                    <ul>
                        <li>
                            <h6>Base Cancellation Fee:</h6>
                            <p>A${cancellationFee}</p>
                        </li>
                        <li>
                            <h6>Waiting Fee:</h6>
                            <p>A${waitingFee}</p>
                        </li>
                        <li>
                            <h6>Total:</h6>
                            <p className={styles.total}>A${totalCancellation}</p>
                        </li>
                    </ul>
                </div>
            }
        </div>
    )
})
export default Fee;